import React from 'react';
import { Chart } from 'common/components/ThemedChart';
import { AutocompleteByWeek } from 'UI/components/atoms/AutocompleteByWeek';

import { DEFAULT_OPTIONS } from './WeeklyMetricTrend.constants';

/**
 * @typedef {Object} WeeklyMetricTrendProps
 * @property {(string | number | object)[][]} data
 * @property {Function} [onSelectWeek]
 * @property {object} [options]
 */

/**
 * @param {WeeklyMetricTrendProps} props
 */
export const WeeklyMetricTrend = ({ data, onSelectWeek, options }) => {
  return (
    <>
      <AutocompleteByWeek onSelectWeek={onSelectWeek} />

      <Chart
        chartType="LineChart"
        data={data}
        data-testid="lineChart"
        height="400px"
        legendToggle
        options={{ ...DEFAULT_OPTIONS, ...options }}
        width="100%"
      />
    </>
  );
};
